import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Stack, Typography } from '@mui/material';

import { useEffect, useState } from 'react';
import { IEvent, IPlace } from '../../models/IEvent';
import { IFanfare } from '../../models/IFanfare';
import ChipExternalLink from '../commons/ChipExternalLink';
import Item from '../commons/Item';
import Text from "../commons/Text";

const fanfaresDatabase: IFanfare[] = require("../../assets/configuration/database/fanfares.json");

interface IEventDialogProps {
    event: IEvent;
    open: boolean;
    onClose: any;
}

const EventDialog = (props: IEventDialogProps) => {

    const {event, open, onClose} = props;
    const [fanfares, setFanfares] = useState([] as IFanfare[]);

    useEffect(() => {
        if (event.fanfares && event.fanfares.length > 0)
            setFanfares(event.fanfares?.map(id => filterFanfareById(id)));
    }, [event.fanfares]);

    const handleClose = () => onClose();

    const displayDate = (dateString: string) => {
        const date = new Date(dateString);
        const formatted = date.toLocaleDateString("fr-FR", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        });
        
        return "📅 Le " + formatted.charAt(0).toLowerCase() + formatted.slice(1);
    }

    const displayPlace = (place: IPlace) =>
        "📍 " + place.name + ", " + place.zipCode + " " + place.city;

     const filterFanfareById = (id: string): IFanfare => {
        const filteredFanfares = fanfaresDatabase.filter(f => f.id === id);
        return filteredFanfares.length > 0 ? filteredFanfares[0] : {} as IFanfare;
    }

    return <>
        <Dialog onClose={handleClose} open={open} maxWidth={'md'}>

            <DialogTitle sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Typography gutterBottom component="div" fontFamily={'AllertaStencil'} fontSize={30}>
                    {event.name}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>

                    <Grid item xs={4} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Box>
                            <img src={event.imageMaxi ? event.imageMaxi : event.image} alt={'Photo ' + event.name} style={{width: '100%'}}/>
                        </Box>
                    </Grid>

                    <Grid item xs={8} sx={{display: 'flex'}}>
                        <DialogContentText>
                            <Text text={displayDate(event.date)} fontSize={20}/>
                            <Text text={displayPlace(event.place)} fontSize={20}/>
                            <Box sx={{margin: "30px 0 50px 0"}}>
                                <Text text={event.description ?? ""} fontSize={16}/>
                            </Box>

                            {event.links && event.links.length > 0 && (
                                <Stack spacing={1} sx={{alignItems: "flex-start", width: "fit-content"}}>
                                    {event.links.map(link => (
                                        <ChipExternalLink key={link.url} label={link.label} url={link.url} />
                                    ))}
                                </Stack>
                            )}
                            
                        </DialogContentText>
                    </Grid>

                </Grid>

                {fanfares.length > 0 && (
                    <Box sx={{marginTop: '40px'}}>
                        <Text text="Lors de cet événement, nous avons joué avec :" fontSize={20}/>
                    
                        <Grid container spacing={2} sx={{marginTop: '0px'}}>
                            {fanfares.map(fanfare =>
                                <Grid item key={fanfare.name} xs={6} md={4} lg={2} xl={2}>
                                    <Item label={fanfare.name} image={fanfare.image} fontSize={20}/>
                                </Grid>)
                            }
                        </Grid>
                    </Box>
                )}

            </DialogContent>

        </Dialog>
    </>
}

export default EventDialog;